import "./css/style.scss";
import VideoCard from "./Components/VideoCard.jsx";

export default function Projects({ content }) {
  return (
    <section>
      <div id="projects" className="projects">
        <div className="container">
          {content.map((item, i) => (
            <VideoCard key={i} props={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
